<div *ngIf="ticketType && !scan" class="container p-4 text-center">
<form [formGroup]="saleForm" (ngSubmit)="sellTicket()">
    <div class="card bg-info text-decoration-none rounded shadow border-primary text-white mb-2">
        <div class="card-body">
            <img *ngIf="event" [src]="event.image" class="w-100" />
            <h6 class="p-3 m-0">#{{ ticketType.id }} - {{ ticketType.name }}</h6>
          <!--  <small class="mb-5">{{ticketType.description}}</small><br> -->
            <small class="badge bg-dark me-3">{{ticketType.price | currency:'HUF':'Ft ':'1.0-0' }}</small>
            <small class="badge bg-dark">{{ ticketType.valid_from | date }} </small>
            <div class="fs-1 fw-bold text-center mt-4 row">
              <div class="col btn btn-info p-1" (click)="updateQuantity(-1)">
                <i class="bi bi-dash m-auto fw-bold" style="font-size: 2.5rem;"></i>
              </div>
              <div class="col">
                <span class="badge bg-dark" style="font-size: 2.5rem;">{{ saleForm.get('quantity')?.value }}</span>
              </div>
              <div class="col btn btn-info p-1 fw-bold" (click)="updateQuantity(1)">
                <i class="bi bi-plus" style="font-size: 2.5rem;"></i>
              </div>
            </div>
        </div>
    </div>

    <div class="input-group mb-4 my-4">
        <input type="hidden" class="form-control" formControlName="quantity"  placeholder="{{ 'ticket_sale.quantity' | translate }}" [class.is-invalid]="saleForm.get('quantity')?.touched && saleForm.get('quantity')?.invalid" required>
        <div *ngIf="saleForm.get('quantity')?.touched && saleForm.get('quantity')?.invalid" class="invalid-feedback text-center">
          <div *ngIf="saleForm.get('quantity')?.errors?.['required']">{{ 'ticket_sale.quantity_required' | translate }}</div>
        </div>
      </div>

      <div class="input-group mb-4 my-4">
        <input type="email" class="form-control" formControlName="email" placeholder="{{ 'ticket_sale.email' | translate }}" [class.is-invalid]="saleForm.get('email')?.touched && saleForm.get('email')?.invalid" >
        <div *ngIf="saleForm.get('email')?.touched && saleForm.get('email')?.invalid" class="invalid-feedback text-center">
          <div *ngIf="saleForm.get('email')?.errors?.['email']">{{ 'ticket_sale.invalid_email_format' | translate }}</div>
        </div>
      </div>

      <div class="input-group mb-4 my-4">
        <input type="text" class="form-control" formControlName="promo_code" (input)="applyDiscount()" placeholder="{{ 'ticket_sale.promo_code' | translate }}" [class.is-invalid]="saleForm.get('promo_code')?.touched && saleForm.get('promo_code')?.invalid" [class.is-valid]="
        saleForm.get('promo_code')?.valid &&
        (saleForm.get('promo_code')?.dirty || saleForm.get('promo_code')?.touched)
      ">
        <button type="button" (click)="scanPromoCode()" class="btn btn-warning"><i class="bi bi-qr-code"></i></button>
        <div *ngIf="saleForm.get('promo_code')?.touched && saleForm.get('promo_code')?.invalid" class="invalid-feedback text-center">
          <div *ngIf="saleForm.get('promo_code')?.errors?.['maxLength']">{{ 'ticket_sale.max_length' | translate }}</div>
        </div>
        <div class="invalid-feedback text-center" *ngIf="saleForm.get('promo_code')?.hasError('invalidPromotionCode')">
          Érvénytelen promóciós kód.
          {{ 'ticket_sale.invalid_code'| translate }}
        </div>
        <div class="invalid-feedback text-center" *ngIf="saleForm.get('promo_code')?.hasError('promotionCodeValidationFailed')">
          {{ 'ticket_sale.error'| translate }}
          Hiba történt a promóciós kód ellenőrzése közben.
        </div>
      </div>

      <div class="input-group mb-4 my-4">
        <select class="form-select" aria-label="Default select example" placeholder="Fizetési módszer" name="payment_method" formControlName="payment_method" [class.is-invalid]="saleForm.get('payment_method')?.touched && saleForm.get('payment_method')?.invalid" required>
          <option value="CARD">{{ 'ticket_sale.card' | translate }}</option>
          <option value="SZEP">{{ 'ticket_sale.szep' | translate }}</option>
          <option value="CASH">{{ 'ticket_sale.cash' | translate }}</option>
          <option value="WIRE">{{ 'ticket_sale.transfer' | translate }}</option>
        </select>
        <div *ngIf="saleForm.get('payment_method')?.touched && saleForm.get('payment_method')?.invalid" class="invalid-feedback text-center">
          <div *ngIf="saleForm.get('payment_method')?.errors?.['payment_method']">{{ 'ticket_sale.invalid_email_format' | translate }}</div>
        </div>
      </div>

      <button type="submit" class="btn border-5 btn-warning w-100 btn-lg"><i class="bi bi-cart-plus fw-bold"></i> {{ 'ticket_sale.sell' | translate }} - <b>{{ ( (saleForm.get('quantity')?.value || 1) * ticketType.price) - this.discount | currency:'HUF':'Ft ':'1.0-0' }}</b></button>
    </form>
    <div class="container mb-5">
    <div class="my-3 row">
      <button [routerLink]="['/sale']"
          class="col me-3 btn btn-secondary btn-lg">
          {{ 'ticket_sale.back_to_ticket_types' | translate }}
    </button>
    <button (click)="resetForm()"
          [disabled]="!saleForm.dirty"
          [ngClass]="{'disabled': !saleForm.dirty}"
      class="col btn btn-danger text-white btn-lg">
      {{ 'ticket_sale.clear_form' | translate }}
  </button>
</div>
    </div>
</div>

<app-validation-popup [reset]="reset" [ticketResponse]="ticketResponse" [mode]="mode" [offline]="offline"></app-validation-popup>

<div *ngIf="scan">
  <app-scanner (readResult)="scanSuccessHandler($event)"></app-scanner>
</div>
